import React from "react";
import Loadable from "../../react-loadable";
const Search = Loadable({
  loader: () => import("./search"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default Search;



// WEBPACK FOOTER //
// ./_antd1.11.2/transfer_browser/SearchAsync.jsx